export const STATUS_META = {
  open: { label: "Open", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", dot: "bg-blue-500" },
  in_progress: { label: "In Progress", bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", dot: "bg-amber-500" },
  waiting_customer: { label: "Waiting on Customer", bg: "bg-fuchsia-50", text: "text-fuchsia-700", border: "border-fuchsia-200", dot: "bg-fuchsia-500" },
  resolved: { label: "Resolved", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500" },
  closed: { label: "Closed", bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200", dot: "bg-slate-400" },
};

export const PRIORITY_META = {
  low: { label: "Low", bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200", indicator: "bg-slate-400" },
  medium: { label: "Medium", bg: "bg-sky-100", text: "text-sky-800", border: "border-sky-300", indicator: "bg-sky-500" },
  high: { label: "High", bg: "bg-orange-100", text: "text-orange-800", border: "border-orange-300", indicator: "bg-orange-500" },
  urgent: { label: "Urgent", bg: "bg-rose-100", text: "text-rose-800", border: "border-rose-300", indicator: "bg-rose-600" },
};

export const CATEGORIES = [
  { value: "general", label: "General Inquiry" },
  { value: "billing", label: "Billing" },
  { value: "technical", label: "Technical Issue" },
  { value: "account", label: "Account & Access" },
  { value: "feature_request", label: "Feature Request" },
  { value: "bug", label: "Bug Report" },
];

export const STATUSES = Object.keys(STATUS_META);
export const PRIORITIES = Object.keys(PRIORITY_META);
